import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";

import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-tfc-res-options',
    imports: [FormsModule, MatIcon],
    templateUrl: './tfc-res-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './tfc-res-options.component.css'
})
export class TfcResOptionsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  unitVoltageSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  fanOptionsSelection!: GuruEntity;
  pumpOptionsSelection!: GuruEntity;
  heatExchangerOptionsSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.OPTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.unitVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnitVoltage');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlOptions');
    this.fanOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFanOptions');
    this.pumpOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPumpOptions');
    this.heatExchangerOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHeatExchangerOptions');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
